module.exports = __webpack_public_path__ + "img/web_ikona.b08e7ab2.svg";